import React, { useReducer, lazy, Suspense } from 'react'
import { ModalInfoSheet } from '@fs/zion-ui'
import useShowArabicExperience from '../../hooks/useShowArabicExperience'

const UserMobile = lazy(() => import('../UserMobile/UserMobile'))
const AuthAccount = lazy(() => import('../../../shared/components/AuthAccount/AuthAccount'))
const NavLinksMobile = lazy(() => import('../NavLinksMobile/NavLinksMobile'))

// exporting to use in stories
export const mobileDrawReducer = (state, action) => {
  const { value, key } = action
  if (state[key] === value) {
    return state
  }
  const newState = { ...state }
  if (value) {
    Object.keys(newState).forEach((name) => {
      newState[name] = false
    })
  }
  newState[key] = value
  return newState
}

export default function MobileDrawer({
  infoSheet,
  helpOthersOverlay,
  signedIn,
  profileName,
  portraitUrl,
  activeRole,
  adminRoles,
  signOutReturnUrl,
  showNavLinksMobile,
  external,
}) {
  const [state, dispatch] = useReducer(mobileDrawReducer, {})
  const showArabicExperience = useShowArabicExperience()
  return (
    <ModalInfoSheet {...infoSheet} size="sm">
      {signedIn ? (
        <Suspense fallback={<div />}>
          <UserMobile
            profileName={profileName}
            portraitUrl={portraitUrl}
            state={state}
            dispatch={dispatch}
            activeRole={activeRole}
            adminRoles={adminRoles}
            signOutReturnUrl={signOutReturnUrl}
            closeInfoSheet={infoSheet.close}
            helpOthersOverlay={helpOthersOverlay}
            external={external}
          />
        </Suspense>
      ) : (
        <Suspense fallback={<div />}>
          <AuthAccount external={external} />
        </Suspense>
      )}
      {showNavLinksMobile && !showArabicExperience && (
        <Suspense fallback={<div />}>
          <NavLinksMobile state={state} dispatch={dispatch} external={external} />
        </Suspense>
      )}
    </ModalInfoSheet>
  )
}
